export enum FeatureFlags {
    customerPortalPaymentMethodsSettings = 'customerPortalPaymentMethodsSettings',
    apBillEditor = 'apBillEditor',
}
